import { priceAnalyticsRepository, type PriceAnalyticsResponse, type PriceCollectStatus, type PriceProductItem } from '../../infrastructure/repositories/PriceAnalyticsRepository';

export class PriceAnalyticsService {
  async getAnalytics(sku: string): Promise<PriceAnalyticsResponse> {
    return priceAnalyticsRepository.getAnalytics(sku);
  }

  async getProducts(limit = 20, offset = 0, search = ''): Promise<{ products: PriceProductItem[]; total: number }> {
    return priceAnalyticsRepository.getProducts(limit, offset, search);
  }

  async triggerCollect(): Promise<void> {
    await priceAnalyticsRepository.triggerCollect();
  }

  async cancelCollect(): Promise<void> {
    await priceAnalyticsRepository.cancelCollect();
  }

  async getStatus(): Promise<PriceCollectStatus> {
    return priceAnalyticsRepository.getStatus();
  }
}

export const priceAnalyticsService = new PriceAnalyticsService();
